import React, { useEffect, useState } from "react";
import { returnModifiedObjectAsConfig } from "../../../commonFunctions/formFunc";
import SingleSelectBox from "../../../components/FormComponents/SingleSelectBox";
import { useTableContext } from "../../../context/TableContext";

const GlobalFieldSelection = ({ value, onChange, tableId }) => {
  const { getSingleTableData } = useTableContext();
  const [allGlobalFields, setAllGlobalFields] = useState({});

  const handleChangeField = (value) => {
    if (!value) {
      onChange({ global_field: {}, components: [] });
      return;
    }

    let components = [];
    if (allGlobalFields[value].field_type === "recordset-list") {
      const newCompo = allGlobalFields[value].sub_fields.map((field) => {
        const obj = {
          id: field.id,
          label: field.display,
          type: field.field_type
        };
        return returnModifiedObjectAsConfig(obj, "form");
      });
      components = newCompo;
    }
    onChange({
      global_field: allGlobalFields[value],
      components: components
    });
  };

  useEffect(() => {
    const { data } = getSingleTableData(tableId);
    const fields =
      data.table.columns_new
        .find((col) => col.activity_id === "global_fields")
        ?.items?.reduce((acc, cur) => {
          return { ...acc, [cur.id]: cur };
        }, {}) || [];
    setAllGlobalFields(fields);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="builder_form">
      <SingleSelectBox
        selectedData={value?.id || ""}
        options={Object.values(allGlobalFields) || []}
        labelKey={["display"]}
        onChange={(obj) => handleChangeField(obj.id)}
        label="Map global data field"
        placeholder="Select field"
        isSearch={true}
      />
    </div>
  );
};

export default GlobalFieldSelection;
